import { Breadcrumbs } from 'AbstractElements';
import ToolLeadsContain from 'Component/Learning/ToolLeads';

const ToolLeadList = () => {
	return (
		<>
			<Breadcrumbs mainTitle="Tool Leads" parent="Users" title="Daftar Tool Leads" />
			<ToolLeadsContain />
		</>
	);
};

export default ToolLeadList;
